import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_5 = {
  key: 1,
  class: "ant-row ss-grade-personalizada-titulo"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Centro de Custos")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "ant-row ss-grade-personalizada-titulo"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Centro de Custo")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-10 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Proporção")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-10 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "ant-col ant-col-xs-2 ant-col-xl-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_19 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-2"
}
const _hoisted_20 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: " " }, {
    default: _withCtx(() => [
      (_ctx.props.editavel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_form_item, {
                label: "Centro de Custo",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_centro_custo, {
                    codigoSelecionado: _ctx.state.centroCustoSelecionado,
                    "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.centroCustoSelecionado) = $event)),
                    descricaoSelecionado: _ctx.state.descricaoCentroCustoSelecionado,
                    "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.descricaoCentroCustoSelecionado) = $event)),
                    ignorarCentroCustos: _ctx.computedCentrosCusto.map(c=>c.codigoCentroCusto)
                  }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "ignorarCentroCustos"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, {
                label: "Proporção",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.state.proporcao,
                    "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.proporcao) = $event)),
                    percentual: true
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria ss-tamanho-completo",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarCentroCusto()))
                  }, "Adicionar")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.storeSistema.state.layoutMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            (_ctx.props.editavel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true)
          ])),
      (_ctx.computedCentrosCusto.length <= 0)
        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
            key: 3,
            mensagem: "Nenhum centro de custo adicionado ainda"
          }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.computedCentrosCusto, (centroCusto, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ant-row ss-grade-personalizada-linha",
              key: index
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_form_item, {
                  label: "Centro de Custo",
                  class: "ss-margin-campos ss-label-show-mobile"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      value: centroCusto.descricaoCentroCusto,
                      disabled: ""
                    }, null, 8, _hoisted_16)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_form_item, {
                  label: "Proporção",
                  class: "ss-margin-campos ss-label-show-mobile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.computedCentrosCusto[index].proporcao,
                      percentual: true,
                      disabled: true,
                      "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => (_ctx.limparCampos()))
                    }, null, 8, ["valor"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_a_form_item, {
                  label: "Valor",
                  class: "ss-margin-campos ss-label-show-mobile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.obterValorProporcao(_ctx.computedCentrosCusto[index].proporcao),
                      monetario: true,
                      disabled: true
                    }, null, 8, ["valor"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              (_ctx.props.editavel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos ss-label-show-mobile"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                          title: "Remover",
                          onClick: ($event: any) => (_ctx.removerCentroCusto(index)),
                          disabled: !_ctx.props.editavel
                        }, [
                          _createVNode(_component_icone, { nome: "excluir" })
                        ], 8, _hoisted_20)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
    ]),
    _: 1
  }))
}